export const GRADES = {
  LOW: 'низкий',
  MID: 'средний',
  HIGH: 'высокий',
};
